import * as dc from "@/components/layout/list/defaultType";
import { RefObject } from "react";
import { ClipboardProp, DataListParams, DataListProp, DataParams, LayoutProps } from "../../layoutType";
import { FormInstance } from "antd";
import {
  convertFormValues,
  getFormDateDiff,
  getInputValueCheck,
  getMatchingData,
  runFormFunction,
  setFormClass,
} from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { DataCols, DataColumnField, DataColumnRecord } from "../../input/inputType";
import { getTranslate } from "@/util/arrayutil";
import { checkEmpty } from "@/util/stringutil";
import { qcCommonCols, qcCommonInit } from "../../inputCols/qcCols";
import { brewingChangeCalc, brewingCommon, brewingDefault, brewingInit, brewingType } from "../../inputCols/brewingCols";
import { brewingClipboard } from "../../inputCols/clipboard";
import { enLocale } from "@/i18n/routing";
export const RoasterQC = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;

  const utcOffset = dayjs().utcOffset() * 60000;

  const qcNamesCols: DataColumnRecord = {
    cupnote_name_locale: { ...dc.inputFull, readOnly: true, noItem: false, saveData: false },
    cupnote_name: { ...dc.inputFull, readOnly: true, noItem: false, saveData: false },
    cupnote_seq: dc.hidden,
  };
  const qcSubCols: DataColumnRecord = {
    cupnote_main: {
      ...dc.use,
      create: { defaultValue: false },
      edit: { enabledUserAuth: { roaster: ["OWN", "SMNG"] } },
    },
    //rgst_at:{...dc.},
    rgst_by: { ...dc.rgst },
    //edit_at:{...dc.},
    edit_by: { ...dc.edit },
  };

  const qcClipboard: ClipboardProp = {
    category: "QCCommon",
    exField: ["roaster_seq", "cupnote_seq"],
    load: (data) => {
      // Debug(data);
      [
        "cupnote_balance_point",
        "cupnote_aroma_point",
        "cupnote_sweetness_point",
        "cupnote_body_point",
        "cupnote_flavor_point",
        "cupnote_acidity_point",
      ].forEach((item) => runFormFunction(formFunction?.current, item, "inputSync"));
      runFormFunction(formFunction?.current, "cupnote_radar", "changeData");
    },
  };
  const qcResultClipboard: ClipboardProp = {
    category: "QCResult",
    exField: ["roaster_seq", "cupnote_seq", "brewing_seq"],
    pasteMatching: ["QCCommon", "BrewingCommon"],
    load: (data) => {
      // Debug(data);
      [
        "cupnote_balance_point",
        "cupnote_aroma_point",
        "cupnote_sweetness_point",
        "cupnote_body_point",
        "cupnote_flavor_point",
        "cupnote_acidity_point",
      ].forEach((item) => runFormFunction(formFunction?.current, item, "inputSync"));
      runFormFunction(formFunction?.current, "cupnote_radar", "changeData");
    },
  };
  const blending_seq: DataColumnField = {
    ...dc.selectSearch,
    label: "blending_select_label",
    labelClassName: dc.strongLabelClassName,
    inputClassName: "w-full",
    widthFull: true,
    tooltip: true,
    tooltipTransition: false,
    tooltipPlacement: "topLeft",
    dataUrl: "/api/roaster/blending/default/code",
    dataLabel: {
      value: "blending_seq",
      label: [
        params?.locale === enLocale
          ? { field: "blending_name", subs: "blending_nick" }
          : { field: "blending_name_locale", subs: "blending_nick_locale" },
      ],
      labelSort: true,
    },
  };

  switch (params?.page.page ?? "") {
    //추출 컵노트
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"cupnote_blending_result","system_table_pk":["roaster_seq","cupnote_date","cupnote_seq"],"system_table_manual_increment":"cupnote_seq","system_table_page":"QCBlendingResult","system_table_path":"roaster/qc/blendingresult","system_table_page_name":"QCBlendingResult","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_table_mapper":"roasterqc","system_table_detail_result":"detail_result","system_table_search_column":["cupnote_date","blending_result_date","cupnote_main"],"system_table_order_column":["cupnote_date","blending_result_date","cupnote_main"]}
    //--info--}

    //추출결과
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"brewing_result","system_table_pk":["roaster_seq","cupnote_date","cupnote_seq"],"system_table_page":"QCBrewingResultBlending","system_table_path":"roaster/qc/brewingresult/blending","system_table_page_name":"QCBrewingResultBlending","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_table_mapper":"roasterqc","system_table_detail_result":"detail_result","system_table_search_column":["brewing_type","brewing_detail_use","brewing_public"]}
    //--info--}

    //추출단계
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"brewing_result_step","system_table_pk":["roaster_seq","cupnote_date","cupnote_seq"],"system_table_page":"QCBrewingResultBlendingStep","system_table_path":"roaster/qc/brewingresult/blendingstep","system_table_page_name":"QCBrewingResultBlendingStep","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_table_mapper":"roasterqc","system_table_detail_result":"detail_result"}
    //--info--}

    case "QCBrewingResult":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/qc/blendingresult/detail/", saveFetch: { fetchUrl: "/api/roaster/qc/blendingresult/edit" } },
        listFetch: { fetchUrl: "/api/roaster/qc/blendingresult/list" },
        dataResultName: "detail_result",
        dataMerge: "detail_result_step",
        dataName: "QCBrewingResultData",
        dataScrollAnimate: false,
        editReload: true,
        editCheck: true,
        clipboard: qcResultClipboard,
        timer: dc.brewingTimer,
        dataInit: (data: any, params: any, mode?: string) => {
          if (params?.setTimer) {
            params.setTimer({ timer: dc.brewingTimer, start: undefined });
          }
          form?.current?.setFieldValue("brewing_date_term", getFormDateDiff(form?.current, "blending_result_date", "cupnote_date"));
          brewingChangeCalc(form?.current, dataFunction?.current);
          setTimeout(() => {
            setFormClass(dataFunction?.current, {
              brewing_detail_use: data["brewing_detail_use"] ?? false,
              brewing_espresso_use: data["brewing_result_type"] === "ESP",
              hidden_step_detail: !((data["brewing_step_use"] ?? 0) === 1),
              hidden_brewing_result: !((data["brewing_result_use"] ?? 0) === 1),
              satis_detail_use: data["cupnote_satis_detail"],
            });
            const objs = document.querySelectorAll("form.ant-form .rt-Flex.data-chart.FlavorWheel svg > g > g");
            if (objs && objs.length > 0) {
              runFormFunction(formFunction?.current, "cupnote_flavor_wheel", "changeData");
              const rotate =
                getInputValueCheck(form?.current, formMemo?.current, dataFunction?.current, data, "cupnote_flavor_wheel_rotate") ?? 0;
              Debug("qcCommonInit", rotate);
              const objs = document.querySelectorAll("form.ant-form .rt-Flex.data-chart.FlavorWheel svg > g > g");
              objs.forEach((g) => {
                const obj = g as SVGGElement;
                const ctm = getTranslate(obj);
                if (ctm) {
                  obj.setAttribute("transform", `translate(${ctm.x}, ${ctm.y}) rotate(${rotate})`);
                }
              });
            }
          }, dc.setTimeoutDelay);
        },
        dataCols: {
          ...qcNamesCols,
          cupnote_seq: dc.hidden,
          brewing_seq: {
            ...dc.brewingSelect(params?.locale, false),
            label: "brewing_select_label",
            dataUrl: "/api/roaster/qc/brewing/default/code",
            onChange: (data) => {
              const temp_result = runFormFunction(formFunction?.current, "brewing_seq", "selectData");
              Debug(temp_result);
              const select_data = temp_result.result;
              if (select_data) {
                const convert_values = convertFormValues(formMemo?.current, select_data, undefined, []);
                if (convert_values) {
                  convert_values["brewing_result_use"] = 1;
                  if (checkEmpty(form?.current?.getFieldValue("blending_result_month"))) convert_values["blending_result_month"] = dayjs();
                  if (checkEmpty(form?.current?.getFieldValue("cupnote_date"))) convert_values["cupnote_date"] = dayjs();
                  form?.current?.setFieldsValue(convert_values);
                  setTimeout(() => {
                    runFormFunction(formFunction?.current, ["blending_seq", "blending_result_seq"], "changeLoad");
                  }, dc.setTimeoutShort);
                }
                setFormClass(dataFunction?.current, {
                  hidden_brewing_result: !true,
                });
                brewingInit(form?.current, formFunction?.current, dataFunction?.current, select_data, params?.setTimer);
              }
            },
            update: { disabled: true, selectPropOption: { reloadButton: false } },
          },
          cupnote_date: {
            ...dc.date,
            noItem: false,
            update: { disabled: true },
            onChange: (e) => {
              const setValues: Record<string, any> = {
                brewing_date_term: getFormDateDiff(form?.current, "blending_result_date", "cupnote_date"),
              };
              if (checkEmpty(form?.current?.getFieldValue("blending_result_month"))) {
                setValues.blending_result_month = e.value;
              }
              form?.current?.setFieldsValue(setValues);
              if (setValues.blending_result_month) {
                setTimeout(() => {
                  runFormFunction(formFunction?.current, "blending_result_seq", "changeLoad");
                }, dc.setTimeoutShort);
              }
            },
          },
          blending_result_month_set: {
            label: "blending_result_month",
            fieldId: {
              blending_result_month: {
                ...dc.month,
                labelClassName: dc.strongLabelClassName,
                update: { disabled: true },
                saveData: false,
                onChange: (data) => {
                  runFormFunction(formFunction?.current, "blending_result_seq", "changeLoad");
                },
              },
            },
          },
          blending_seq: {
            ...blending_seq,
            dataProp: {
              fixedParam: { check_cupnote: true },
            },
            create: {
              dataProp: {
                fixedParam: { check_cupnote: true },
                load: (data, select_data) => {
                  Debug(select_data);
                  if (select_data) {
                    const result = getMatchingData(form?.current, formMemo?.current, select_data, undefined, [
                      "cupnote_acidity_point",
                      "cupnote_aftertaste_list",
                      "cupnote_aroma_point",
                      "cupnote_balance_point",
                      "cupnote_body_point",
                      "cupnote_feeling_list",
                      "cupnote_flavor_list",
                      "cupnote_flavor_point",
                      "cupnote_flavor_wheel_rotate",
                      "cupnote_flavor_wheel_simple",
                      "cupnote_flavor_wheel_use",
                      "cupnote_satis",
                      "cupnote_satis_detail",
                      "cupnote_sweetness_point",
                      "cupnote_texture_list",
                    ]);
                    if (!checkEmpty(result)) {
                      form?.current?.setFieldsValue(result);
                      setTimeout(() => {
                        qcCommonInit(select_data, form?.current, formMemo?.current, formFunction?.current, dataFunction?.current);
                        [
                          "cupnote_satis",
                          "cupnote_flavor_wheel_rotate",
                          "cupnote_balance_point",
                          "cupnote_aroma_point",
                          "cupnote_sweetness_point",
                          "cupnote_body_point",
                          "cupnote_flavor_point",
                          "cupnote_acidity_point",
                        ].forEach((item) => runFormFunction(formFunction?.current, item, "inputSync"));
                      }, dc.setTimeoutDelay * 1.5);
                    }
                  }
                },
              },
            },
            update: { disabled: true, selectPropOption: { reloadButton: false } },
            onChange: (data) => {
              const temp_result = runFormFunction(formFunction?.current, "blending_seq", "selectData");
              const select_data = temp_result.result;
              if (select_data) {
                const result = getMatchingData(form?.current, formMemo?.current, select_data, undefined, [
                  "cupnote_acidity_point",
                  "cupnote_aftertaste_list",
                  "cupnote_aroma_point",
                  "cupnote_balance_point",
                  "cupnote_body_point",
                  "cupnote_feeling_list",
                  "cupnote_flavor_list",
                  "cupnote_flavor_point",
                  "cupnote_flavor_wheel_rotate",
                  "cupnote_flavor_wheel_simple",
                  "cupnote_flavor_wheel_use",
                  "cupnote_satis",
                  "cupnote_satis_detail",
                  "cupnote_sweetness_point",
                  "cupnote_texture_list",
                ]);
                if (!checkEmpty(result)) {
                  form?.current?.setFieldsValue(result);
                  setTimeout(() => {
                    qcCommonInit(select_data, form?.current, formMemo?.current, formFunction?.current, dataFunction?.current);
                    [
                      "cupnote_satis",
                      "cupnote_flavor_wheel_rotate",
                      "cupnote_balance_point",
                      "cupnote_aroma_point",
                      "cupnote_sweetness_point",
                      "cupnote_body_point",
                      "cupnote_flavor_point",
                      "cupnote_acidity_point",
                    ].forEach((item) => runFormFunction(formFunction?.current, item, "inputSync"));
                  }, dc.setTimeoutDelay);
                }
              }
            },

            selectChangeLoad: "blending_result_seq",
          },
          blending_result_seq: {
            ...dc.selectSearch,
            label: "blending_result_select_label",
            labelClassName: dc.strongLabelClassName,
            inputClassName: "w-full",
            widthFull: true,
            tooltip: true,
            tooltipTransition: false,
            tooltipPlacement: "topLeft",
            dataUrl: "/api/roaster/blending/result/code",
            dataProp: {
              valueParam: { blending_result_month: "blending_result_month" },
              fixedParam: { check_instock: false },
              requiredParam: ["blending_result_month"],
              load: (data, select_data, field, index, change) => {
                Debug(select_data);
                if (select_data) {
                  const result = getMatchingData(form?.current, formMemo?.current, select_data, undefined, [
                    "blending_loss",
                    "blending_organic_loss",
                    "blending_result_year",
                    "blending_result_date",
                  ]);
                  form?.current?.setFieldsValue({ ...result, blending_result_month: result["blending_result_date"] });
                } else {
                  form?.current?.setFieldsValue({
                    blending_result_year: undefined,
                    blending_result_date: undefined,
                    blending_loss: undefined,
                    blending_organic_loss: undefined,
                  });
                }
                form?.current?.setFieldValue("brewing_date_term", getFormDateDiff(form?.current, "blending_result_date", "cupnote_date"));
              },
            },
            onChange: (data) => {
              const temp_result = runFormFunction(formFunction?.current, "blending_result_seq", "selectData");
              const select_data = temp_result.result;
              Debug(select_data);
              if (select_data) {
                form?.current?.setFieldsValue({
                  blending_result_year: dayjs(select_data["blending_result_year"] + ""),
                  blending_result_month: dayjs(select_data["blending_result_date"]),
                  blending_result_date: dayjs(select_data["blending_result_date"]),
                });
              } else {
                form?.current?.setFieldsValue({
                  blending_result_year: undefined,
                  blending_result_date: undefined,
                });
              }
              form?.current?.setFieldValue("brewing_date_term", getFormDateDiff(form?.current, "blending_result_date", "cupnote_date"));
            },
            dataLabel: {
              value: "blending_result_seq",
              label: ["blending_result_date", params?.locale === enLocale ? "blending_name" : "blending_name_locale"],
              labelSort: -1,
            },
            selectFieldFilter: { blending_seq: "blending_seq" },
            selectFieldRequired: "blending_result_month",
            selectPropOption: { setEmptyValue: 0 },
            update: { disabled: true, selectPropOption: { reloadButton: false } },
          },
          blending_result_date: {
            // itemClassName: "hidden",
            fieldId: {
              blending_result_year: {
                ...dc.year,
                dateProp: { nowButton: false },
                disabled: true,
                // update: { disabled: true },
                onChange: (data) => {
                  runFormFunction(formFunction?.current, "blending_result_seq", "changeLoad");
                },
              },
              blending_result_date: {
                ...dc.date,
                dateProp: { nowButton: false },
                disabled: true,
                noItem: false,
                // update: { disabled: true },
              },
              brewing_date_term: {
                ...dc.number,
                inputClassName: "text-last",
                unitPrev: "+",
                unit: { element: "day_unit", transition: true },

                noItem: false,
                disabled: true,
                tooltip: "brewing_date_term",
              },
            },
          },
          // blending_result_select: {
          //       label: "blending_result_select_label",
          //       labelClassName: dc.strongLabelClassName,
          //       fieldId: {
          //       },
          //     },

          div_0: { ...dc.itemDiv, itemClassName: dc.itemDiv.itemClassName + " brewing_result" },
          brewing_result_use: {
            ...dc.use,
            inputClassName: "my-auto",
            read: { display: false },
            create: { defaultValue: false },
            onChange: (e) => {
              setFormClass(dataFunction?.current, { hidden_brewing_result: !e.value });
            },
            changePass: true,
          },

          ...brewingDefault(
            t,
            form,
            formMemo?.current,
            formFunction?.current,
            dataFunction?.current,
            params?.setTimer,
            params?.locale,
            "roaster",
            "result",
            false,
          ),
          condition: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            itemClassName: "brewing_result",
            read: { display: "notNull", displayCheckIds: ["outside_air", "inside_air", "outside_hum", "inside_hum"] },
            fieldId: {
              condition_air: {
                ...dc.airTemp,
                readOnly: true,
                disabled: true,
                variant: "borderless",
                unit: "",
              },
              condition_hum: {
                ...dc.hum,
                readOnly: true,
                disabled: true,
                variant: "borderless",
                unit: "",
                read: { display: "notNull", displayCheckIds: ["outside_hum", "inside_hum"] },
              },
            },
          },
          outside: {
            itemClassName: "brewing_result",
            read: { display: "notNull", displayCheckIds: ["outside_air", "outside_hum"] },
            edit: { label: dc.weatherButton(form) },
            fieldId: {
              outside_air: dc.airTemp,
              outside_hum: { ...dc.hum, read: { display: "notNull", displayCheckIds: undefined } },
            },
          },
          inside: {
            itemClassName: "brewing_result",
            read: { display: "notNull", displayCheckIds: ["inside_air", "inside_hum"] },
            fieldId: {
              inside_air: dc.airTemp,
              inside_hum: { ...dc.hum, read: { display: "notNull", displayCheckIds: undefined } },
            },
          },

          // brewing_public: { ...dc.use, itemClassName: "brewing_result" },
          // brewing_default_memo: { ...dc.textArea, textAreaProp: { rows: 10 }, maxLength: 3000, read: { display: "notNull" } },
          brewing_split: {
            label: "blank",
            itemClassName: "!hidden",
          },
          ...qcCommonCols(
            form,
            formFunction?.current,
            dataFunction?.current,
            params?.locale,
            [params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale"],
            alertContext,
            ta,
            "Coffee",
          ),
          ...qcSubCols,
        },
        listColLinkField: ["cupnote_date", "cupnote_seq"],

        listSearch: [
          { ...dc.date, field: "search0", label: "cupnote_date", placeholder: "cupnote_date", defaultValue: undefined },
          { ...dc.date, field: "search1", label: "blending_result_date", placeholder: "blending_result_date", defaultValue: undefined },
          { ...dc.listSearchUse, field: "search2", label: "cupnote_main", placeholder: "cupnote_main" },
        ],

        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "cupnote_name_locale", placeholder: "cupnote_name" },
          // { ...dc.input, field: "search_type0", label: "brewing_name_locale", placeholder: "brewing_name_locale" },
          // { ...dc.input, field: "search_type1", label: "brewing_name", placeholder: "brewing_name" },
        ],
        listOrder: [
          "cupnote_date_orderdesc",
          "cupnote_date_orderasc",
          "cupnote_main_orderdesc",
          "cupnote_main_orderasc",
          "blending_result_date_orderdesc",
          "blending_result_date_orderasc",
        ],
        listCols: [
          // "roaster_seq",
          // "blending_seq",
          { field: "cupnote_date", ...dc.date, dateFormatter: props.isMobile ? "MM-DD" : "YYYY-MM-DD" },
          "brewing_date_term",
          // "blending_result_date",
          params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale",
          // "cupnote_seq",
          { field: "blending_loss", ...dc.percent, step: 0.1, label: "loss_rate" },
          { field: "brewing_grinder_point", scale: 100 },
          { field: "brewing_grinder_zeropoint", label: "grinder_zeropoint", scale: 100 },
          { field: "brewing_bean_mass", ...dc.mass },
          { field: "brewing_mass", ...dc.mass },
          {
            field: "cupnote_main",
            label: "cupnote_main_list_label",
            transition: true,
            valueList: dc.listUseLabel,
          },
        ],
        listColMobileTitle: params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale",
        mobileHidden: ["brewing_date_term", "blending_loss"],
      };

    //추출기본설정
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"brewing_default","system_table_pk":["roaster_seq","brewing_seq"],"system_table_manual_increment":"brewing_seq","system_table_page":"QCBrewingDefault","system_table_path":"api/roaster/qc/brewing/default","system_table_page_name":"QCBrewingDefault","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_table_mapper":"roasterqc","system_table_detail_result":"detail_result","system_table_search_column":["brewing_type","brewing_public"],"system_table_search_select":["brewing_name_locale","brewing_name"],"system_table_order_column":["brewing_type"],"system_table_default_name_column":"brewing_name_locale","system_table_en_name_column":"brewing_name","system_table_use_column":"brewing_use"}
    //--info--}

    //추출단계
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"brewing_default_step","system_table_pk":["roaster_seq","brewing_seq"],"system_table_page":"QCBrewingDefaultStep","system_table_path":"api/roaster/qc/brewing/defaultstep","system_table_page_name":"QCBrewingDefaultStep","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_table_mapper":"roasterqc","system_table_detail_result":"detail_result"}
    //--info--}

    case "QCBrewingDefault":
      return {
        ...result,
        dataFetch: {
          fetchUrl: "/api/roaster/qc/brewing/default/detail/",
          saveFetch: { fetchUrl: "/api/roaster/qc/brewing/default/edit" },
        },
        listFetch: { fetchUrl: "/api/roaster/qc/brewing/default/list" },
        dataResultName: "detail_result",
        dataMerge: "detail_result_step",
        dataName: "QCBrewingDefaultData",
        editReload: true,
        clipboard: brewingClipboard,
        dataInit: (data: any) => brewingInit(form?.current, formFunction?.current, dataFunction?.current, data, params?.setTimer),
        dataCols: {
          brewing_name_locale: {
            ...dc.inputFull,
            minLength: params?.locale !== enLocale ? 3 : undefined,
            maxLength: 300,
            showCount: true,
            labelClassName: dc.strongLabelClassName,
            required: params?.locale !== enLocale ? true : undefined,
            read: { variant: "borderless" },
          },
          brewing_name: {
            ...dc.inputFull,
            minLength: params?.locale === enLocale ? 3 : undefined,
            maxLength: 300,
            showCount: true,
            labelClassName: dc.strongLabelClassName,
            required: params?.locale === enLocale ? true : undefined,
            read: { variant: "borderless" },
          },
          blending_seq: {
            ...blending_seq,
            labelClassName: "",
            onChange: (data) => {
              const temp_result = runFormFunction(formFunction?.current, "blending_seq", "selectData");
              const select_data = temp_result.result;
              if (select_data) {
                form?.current?.setFieldsValue({
                  brewing_name_locale: select_data["blending_name_locale"],
                  brewing_name: select_data["blending_name"],
                });
              }
            },
          },
          ...brewingDefault(
            t,
            form,
            formMemo?.current,
            formFunction?.current,
            dataFunction?.current,
            params?.setTimer,
            params?.locale,
            "roaster",
            "default",
            true,
          ),
          // brewing_public: { ...dc.use },
          public_type: { ...dc.publicType },
          public_uuid: { ...dc.publicUUID("/info/brewing/roaster/") },
          brewing_use: { ...dc.useDefault },

          rgst_by: { ...dc.rgst },
          edit_by: { ...dc.edit },
        },
        listColLinkField: "brewing_seq",
        listColDesc: dc.brewingSummary(params?.locale),
        listSearch: [
          { ...dc.select, field: "search0", codeGroup: "EXTR", label: "brewing_type", placeholder: "brewing_type" },
          { ...dc.listSearchUse, field: "search1", label: "brewing_public", placeholder: "brewing_public" },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "brewing_name_locale", placeholder: "brewing_name_locale" },
          // { ...dc.input, field: "search_type0", label: "brewing_name_locale", placeholder: "brewing_name_locale" },
          // { ...dc.input, field: "search_type1", label: "brewing_name", placeholder: "brewing_name" },
        ],
        listOrder: ["brewing_type_orderasc", "brewing_type_orderdesc"],
        listCols: [
          // "roaster_seq",
          // "brewing_seq",
          { field: "brewing_type", codeGroup: "EXTR" },
          params?.locale === enLocale ? "brewing_name" : "brewing_name_locale",
          { field: "brewing_grinder_point", scale: 100 },
          { field: "brewing_bean_mass", ...dc.mass },
          { field: "brewing_mass", ...dc.mass },
          { field: "public_type", codeGroup: "PBTP" },
        ],
        listColMobileTitle: params?.locale === enLocale ? "brewing_name" : "brewing_name_locale",
        // mobileHidden: ["brewing_type", "brewing_public"],
      };
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"cupnote_blending","system_table_pk":["roaster_seq","blending_seq","cupnote_seq"],"system_table_manual_increment":"cupnote_seq","system_table_page":"QCBlending","system_table_path":"api/roaster/qc/blending","system_table_page_name":"QCBlending","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_table_mapper":"roasterqc","system_table_detail_result":"detail_result","system_table_search_column":["cupnote_main","blending_seq"],"system_table_order_column":["cupnote_main"]}
    //--info--}
    case "QCBlending":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/qc/blending/detail/", saveFetch: { fetchUrl: "/api/roaster/qc/blending/edit" } },
        listFetch: { fetchUrl: "/api/roaster/qc/blending/list" },
        dataResultName: "detail_result",
        dataName: "QCBlendingData",
        clipboard: qcClipboard,
        editReload: true,
        editCheck: true,
        resetClassList: false,
        dataInit: (data: any) => {
          qcCommonInit(data, form?.current, formMemo?.current, formFunction?.current, dataFunction?.current);
        },
        dataCols: {
          blending_seq: {
            ...blending_seq,
            dataProp: {
              load: (data, select_data) => {
                Debug(data, select_data);
                if (select_data) {
                  form?.current?.setFieldsValue({
                    cupnote_name_locale: select_data["blending_name_locale"],
                    cupnote_name: select_data["blending_name"],
                  });
                  setTimeout(() => {
                    runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
                  }, dc.setTimeoutDelay);
                }
              },
            },
            // selectPropOption: { reloadButtonFront: true },
            // selectWithLoad: selectWithList,
            onChange: (data) => {
              const temp_result = runFormFunction(formFunction?.current, "blending_seq", "selectData");
              const select_data = temp_result.result;
              if (select_data) {
                form?.current?.setFieldsValue({
                  cupnote_name_locale: select_data["blending_name_locale"],
                  cupnote_name: select_data["blending_name"],
                });
                setTimeout(() => {
                  runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
                }, dc.setTimeoutDelay);
              }
            },
            // onPressEnter: (e) => {
            //   //addGreenbeanList(false);
            // },
          },
          ...qcNamesCols,
          ...qcCommonCols(
            form,
            formFunction?.current,
            dataFunction?.current,
            params?.locale,
            [params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale"],
            alertContext,
            ta,
          ),
          ...qcSubCols,
        },
        listColLinkField: ["blending_seq", "cupnote_seq"],
        listSearch: [
          // { ...dc.year, field: "search0", label: "roasting_result_year", placeholder: "roasting_result_year" },
          // { ...dc.date, field: "search1", label: "roasting_result_date", placeholder: "roasting_result_date" },
          { ...dc.listSearchUse, field: "search0", label: "cupnote_main", placeholder: "cupnote_main" },
        ],
        listSearchSelect: [{ ...dc.input, field: "search_title_all", label: "cupnote_name_locale", placeholder: "cupnote_name_locale" }],
        listOrder: ["cupnote_main_orderdesc", "cupnote_main_orderasc", "cupnote_name_locale_orderasc", "cupnote_name_locale_orderdesc"],
        listCols: [
          // "roaster_seq",
          // "blending_seq",
          params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale",
          // "cupnote_seq",
          "rgst_user",
          {
            field: "cupnote_main",
            label: "cupnote_main_list_label",
            transition: true,
            valueList: dc.listUseLabel,
          },
        ],
        listColMobileTitle: params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale",
      };

    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"cupnote_roasting_result","system_table_pk":["roaster_seq","roasting_result_year","roasting_result_seq","cupnote_seq"],"system_table_manual_increment":"cupnote_seq","system_table_page":"QCRoasting","system_table_path":"api/roaster/qc/roasting","system_table_page_name":"QCRoasting","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_table_mapper":"roasterqc","system_table_detail_result":"detail_result"}
    //--info--}
    case "QCRoasting":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/qc/roasting/detail/", saveFetch: { fetchUrl: "/api/roaster/qc/roasting/edit" } },
        listFetch: { fetchUrl: "/api/roaster/qc/roasting/list" },
        dataResultName: "detail_result",
        dataName: "QCRoastingData",
        clipboard: qcClipboard,
        // editReload: true,
        editCheck: true,
        resetClassList: false,
        dataInit: (data: any) => {
          qcCommonInit(data, form?.current, formMemo?.current, formFunction?.current, dataFunction?.current);
        },
        dataCols: {
          roasting_result_year: {
            ...dc.year,
            inputClassName: dc.selectYearWidth,
            // dateProp: { nowButton: false },
            // edit: { defaultValue: dayjs(new Date()).year() },

            placeholder: "year_select",
            onChange: (e) => {
              Debug(e);
              runFormFunction(formFunction?.current, "roasting_result_seq", "changeLoad");
            },
          },
          roasting_result_seq: {
            ...dc.selectSearch,
            inputClassName: dc.greenbeanSeqWidth,
            //dataUrl: "/api/roaster/roasting/result/code",
            dataUrl: "/api/roaster/roasting/result/code",
            dataProp: {
              fixedParam: { check_instock: false },
              valueParam: { roasting_result_year: "roasting_result_year" },
              requiredParam: ["roasting_result_year"],
              // firstReload: true,
              load: (data, select_data) => {
                Debug(data, select_data);
                if (select_data) {
                  form?.current?.setFieldsValue({
                    cupnote_name_locale: select_data["roasting_name_locale"],
                    cupnote_name: select_data["roasting_name"],
                  });
                  setTimeout(() => {
                    runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
                  }, dc.setTimeoutDelay);
                }
              },
            },
            widthFull: true,
            dataLabel: {
              value: "roasting_result_seq",
              label: [
                "roasting_result_date",
                "roasting_batch_no",
                params?.locale === enLocale
                  ? { field: "roasting_name", subs: "roasting_nick" }
                  : { field: "roasting_name_locale", subs: "roasting_nick_locale" },
              ],
              labelSort: -1,
            },
            // selectPropOption: { reloadButton: false },
            //selectWithLoad: resultSelectWithList,
            //selectChangeLoad: "roasting_greenbean_year",
            selectFieldFilter: { roasting_result_year: "roasting_result_year" },
            selectFieldRequired: "roasting_result_year",
            onChange: (data) => {
              const temp_result = runFormFunction(formFunction?.current, "roasting_result_seq", "selectData");
              const select_data = temp_result.result;
              if (select_data) {
                form?.current?.setFieldsValue({
                  cupnote_name_locale: select_data["roasting_name_locale"],
                  cupnote_name: select_data["roasting_name"],
                });
                setTimeout(() => {
                  runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
                }, dc.setTimeoutDelay);
              }
            },
            tooltip: true,
            tooltipTransition: false,
            read: { tooltipPlacement: "topLeft" },
          },

          ...qcNamesCols,
          ...qcCommonCols(
            form,
            formFunction?.current,
            dataFunction?.current,
            params?.locale,
            [params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale"],
            alertContext,
            ta,
          ),
          ...qcSubCols,
        },
        listColLinkField: ["roasting_result_year", "roasting_result_seq", "cupnote_seq"],
        listSearch: [
          { ...dc.year, field: "search0", label: "roasting_result_year", placeholder: "roasting_result_year" },
          { ...dc.date, field: "search1", label: "roasting_result_date", placeholder: "roasting_result_date" },
          { ...dc.listSearchUse, field: "search2", label: "cupnote_main", placeholder: "cupnote_main" },
        ],
        listSearchSelect: [{ ...dc.input, field: "search_title_all", label: "cupnote_name_locale", placeholder: "cupnote_name_locale" }],
        listOrder: ["cupnote_main_orderdesc", "cupnote_main_orderasc", "cupnote_name_locale_orderasc", "cupnote_name_locale_orderdesc"],
        listCols: [
          // "roaster_seq",
          // "roasting_result_year",
          "roasting_result_date",
          // "greenbean_roaster_seq",
          params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale",
          // "cupnote_seq",
          "rgst_user",
          {
            field: "cupnote_main",
            label: "cupnote_main_list_label",
            transition: true,
            valueList: dc.listUseLabel,
          },
        ],
        listColMobileTitle: params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale",
      };

    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"cupnote_greenbean_year","system_table_pk":["roaster_seq","greenbean_year","greenbean_roaster_seq","cupnote_seq"],"system_table_manual_increment":"cupnote_seq","system_table_page":"QCGreenbean","system_table_path":"api/roaster/qc/greenbean","system_table_page_name":"QCGreenbean","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_table_mapper":"roasterqc","system_table_detail_result":"detail_result","system_table_search_column":["greenbean_year","greenbean_roaster_seq"]}
    //--info--}
    case "QCGreenbean":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/roaster/qc/greenbean/detail/", saveFetch: { fetchUrl: "/api/roaster/qc/greenbean/edit" } },
        listFetch: { fetchUrl: "/api/roaster/qc/greenbean/list" },
        dataResultName: "detail_result",
        dataName: "QCGreenbeanData",
        clipboard: qcClipboard,
        // dataScrollAnimate: false,
        // editReload: true,
        editCheck: true,
        resetClassList: false,
        dataInit: (data: any) => {
          qcCommonInit(data, form?.current, formMemo?.current, formFunction?.current, dataFunction?.current);
        },
        dataCols: {
          greenbean_year: {
            ...dc.year,
            onChange: (data) => {
              Debug(data);
              runFormFunction(formFunction?.current, "greenbean_roaster_seq", "changeLoad");
            },
            update: { disabled: true },
            required: true,
          },
          greenbean_roaster_seq: {
            ...dc.selectSearch,
            inputClassName: dc.greenbeanSeqWidth,
            dataUrl: "/api/roaster/greenbean/year/code",
            dataProp: {
              fixedParam: { check_instock: false },
              valueParam: { greenbean_year: "greenbean_year" },
              requiredParam: ["greenbean_year"],
              start: () => {
                Debug("greenbean_roaster_seq Load Start");
              },
              load: (data, select_data, field, index, change) => {
                Debug("greenbean_roaster_seq Load", data, select_data);
                if (select_data) {
                  form?.current?.setFieldsValue({
                    cupnote_name_locale: select_data["greenbean_name_locale"],
                    cupnote_name: select_data["greenbean_name"],
                  });
                  setTimeout(() => {
                    runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
                  }, dc.setTimeoutDelay);
                }
              },
              // load: (data, select_data) => {
              //   Debug(data, select_data);
              // },
            },
            dataLabel: {
              value: "greenbean_roaster_seq",
              label: [
                params?.locale === enLocale
                  ? { field: "greenbean_name", subs: "greenbean_nick" }
                  : { field: "greenbean_name_locale", subs: "greenbean_nick_locale" },
              ],
              labelSort: true,
            },
            widthFull: true,
            selectPropOption: { setEmptyValue: 0 },
            selectFieldRequired: "greenbean_year",
            onChange: (data) => {
              const temp_result = runFormFunction(formFunction?.current, "greenbean_roaster_seq", "selectData");
              const select_data = temp_result.result;
              if (select_data) {
                form?.current?.setFieldsValue({
                  cupnote_name_locale: select_data["greenbean_name_locale"],
                  cupnote_name: select_data["greenbean_name"],
                });
                setTimeout(() => {
                  runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
                }, dc.setTimeoutDelay);
              }
            },
            tooltip: true,
            tooltipTransition: false,
            read: { tooltipPlacement: "topLeft" },
            update: { disabled: true },
            required: true,
          },
          ...qcNamesCols,
          ...qcCommonCols(
            form,
            formFunction?.current,
            dataFunction?.current,
            params?.locale,
            [params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale"],
            alertContext,
            ta,
          ),
          ...qcSubCols,
        },
        listColLinkField: ["greenbean_year", "greenbean_roaster_seq", "cupnote_seq"],
        listSearch: [
          { ...dc.year, field: "search0", label: "greenbean_year", placeholder: "greenbean_year" },
          { ...dc.listSearchUse, field: "search1", label: "cupnote_main", placeholder: "cupnote_main" },
        ],
        listSearchSelect: [{ ...dc.input, field: "search_title_all", label: "cupnote_name_locale", placeholder: "cupnote_name_locale" }],
        listOrder: ["cupnote_main_orderdesc", "cupnote_main_orderasc", "cupnote_name_locale_orderasc", "cupnote_name_locale_orderdesc"],
        listCols: [
          // "roaster_seq",
          "greenbean_year",
          // "greenbean_roaster_seq",
          params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale",
          // "cupnote_seq",
          "rgst_user",
          {
            field: "cupnote_main",
            label: "cupnote_main_list_label",
            transition: true,
            valueList: dc.listUseLabel,
          },
        ],
        listColMobileTitle: params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale",
      };

    default:
      return undefined;
  }
};
